import { ICreateItemChecklistEntregaUseCase } from "../../../presentation/useCases/create/create_item_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateItemChecklistEntregaUseCase
 */

export class CreateItemChecklistEntregaUseCase implements ICreateItemChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntrega: number,
    descricao?: string,
    ordem?: string,
  ): Promise<number> {
    return this.repository.createItemChecklistEntrega(
      idChecklistEntrega,
      descricao,
      ordem,
    );
  }

}
